import { concatMap, map } from "rxjs";
import { UserToken } from "../../../model/User/UserToken";
import generateSecureToken from "../../../utils/generateSecureToken";
import { apiService } from "../../ApiService";
import { LoginUserAmazonFormData } from "./amazonLogin";

export type AmazonCreateUserOpt = {
  birthDate?: string;
  attribution?: Record<string, string>;
  newsletter?: boolean;
};
export const amazonCreate = (
  data: LoginUserAmazonFormData,
  opts?: AmazonCreateUserOpt,
) => {
  return generateSecureToken(apiService.userAgent).pipe(
    concatMap((secureToken) => {
      return apiService
        .post<UserToken>({
          path: `v1/amazon/account`,
          body: { userInfo: { ...data }, ...opts },
          secureToken: secureToken,
        })
        .pipe(
          map((token) => {
            apiService.familyToken = token.familyToken;
            apiService.userToken = token.userToken;
            return token;
          }),
        );
    }),
  );
};
